/* ── FAQ page (IncomeBazaar redesign) ── */
.faq {
  display: flex;
  flex-direction: column;
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
  padding: 24px 28px 28px;
  margin: 24px 24px 40px;
}

/* ── header ── */
.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 18px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--ib-line-2);
}

.headerText {
  display: flex;
  align-items: center;
}

.backButton {
  margin-right: 0.5rem;
}

.title {
  font-family: var(--font-serif);
  letter-spacing: -0.01em;
  color: var(--ib-ink);
}

.contact {
  color: var(--ib-muted);
}

.contact a {
  color: var(--ib-red);
  font-weight: 600;
  text-decoration: none;
}

.contact a:hover {
  color: var(--ib-red-d);
  text-decoration: underline;
}

/* ── category (outer, ghost) collapse ── */
.titleText {
  color: var(--ib-ink);
}

.faq :global(.ant-collapse-ghost) {
  background: transparent;
}

.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item) {
  border-bottom: 1px solid var(--ib-line-2);
}

.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item:last-child) {
  border-bottom: 0;
}

.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item) > :global(.ant-collapse-header) {
  align-items: center;
  padding: 16px 4px;
  color: var(--ib-ink);
  border-radius: 8px;
}

.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item) > :global(.ant-collapse-header):hover {
  background: var(--ib-line-2);
}

.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item-active) > :global(.ant-collapse-header) {
  color: var(--ib-red);
}

/* Text component sets an inline color, so the active-red must win with !important */
.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item-active) > :global(.ant-collapse-header) .titleText {
  color: var(--ib-red) !important;
}

/* expand chevron in red */
.faq :global(.ant-collapse-expand-icon) {
  color: var(--ib-red);
}

/* outer body padding */
.faq :global(.ant-collapse-ghost) > :global(.ant-collapse-item) > :global(.ant-collapse-content) > :global(.ant-collapse-content-box) {
  padding: 4px 0 14px;
}

/* ── question rows (inner) collapse ── */
.queryClusters {
  display: flex;
  flex-direction: column;
}

.queryClusters :global(.ant-collapse) {
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 12px;
  overflow: hidden;
}

.queryClusters :global(.ant-collapse-item) {
  border-bottom: 1px solid var(--ib-line-2);
}

.queryClusters :global(.ant-collapse-item:last-child) {
  border-bottom: 0;
}

.queryClusters :global(.ant-collapse-header) {
  align-items: center;
  padding: 14px 16px;
  color: var(--ib-ink);
  transition: background 0.15s ease;
}

.queryClusters :global(.ant-collapse-header):hover {
  background: var(--ib-chip);
}

.queryClusters :global(.ant-collapse-item-active) > :global(.ant-collapse-header) {
  background: var(--ib-red-soft);
  color: var(--ib-red);
}

.queryClusters :global(.ant-collapse-item-active) > :global(.ant-collapse-header) :global(.ant-collapse-header-text) span {
  color: var(--ib-red) !important;
}

/* answer body */
.queryClusters :global(.ant-collapse-content) {
  background: var(--ib-panel);
  border-top: 1px solid var(--ib-line-2);
}

.queryClusters :global(.ant-collapse-content-box) {
  padding: 14px 16px 16px;
}

.answer {
  color: var(--ib-muted) !important;
  line-height: 1.7;
}

.answer p {
  margin: 0;
}

@media only screen and (max-width: 560px) {
  .faq {
    margin: 16px 12px 28px;
    padding: 18px 16px 20px;
  }
}
